import React, {useState, useEffect} from 'react';
import Form from "react-bootstrap/Form";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Button from 'react-bootstrap/Button';

function TakeDelivery() {
  const [LineItems, setLineItems] = useState([
    {
      id: "",
      product_id: "",
      stock_type: "",
      quantity: "",
      length: "",
      width: "",
      consumable_type: "",
      consumable_quantity: ""
    }
  ])

  const fetchLineItems = async () => {
    try {
      const response = await fetch('http://127.0.0.1:3000/purchaseorders/4/line_items.json');
      const data = await response.json(JSON.parse);
      setLineItems(data);
    }
    catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    fetchLineItems()
  }, [])

  return (
    <Form>
      <h1>Take Delivery Form</h1>
      <h3>Rolls</h3>
      {LineItems.filter(item => item.stock_type == "StockFlooringRoll").map((form, index) => {
        return (
          <div key={index}>
            <Row>
                <InputGroup>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_product_label" label="Product ID" className="mb-3">
                      <Form.Control
                        type="number"
                        value={form.product_id}
                        readOnly
                      />
                    </FloatingLabel>
                  </Col>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_quantity_label" label="Quantity" className="mb-3">
                      <Form.Control
                        type="number"
                        value={form.quantity}
                        readOnly
                      />
                    </FloatingLabel>
                  </Col>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_quantity_label" label="Length" className="mb-3">
                      <Form.Control
                        type="number"
                        value={form.length}
                        readOnly
                      />
                    </FloatingLabel>
                  </Col>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_quantity_label" label="Width" className="mb-3">
                      <Form.Control
                        type="number"
                        value={form.width}
                        readOnly
                      />
                    </FloatingLabel>
                  </Col>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_condition_label" label="Condition" className="mb-3">
                      <Form.Select>
                        <option>Please choose an option</option>
                        <option value="1">Accepted</option>
                        <option value="2">Damaged</option>
                        <option value="3">Faulty</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                </InputGroup>
            </Row>
          </div>
        )
      })}
      <h3>Consumables</h3>
      {LineItems.filter(item => item.stock_type == "StockConsumable").map((form, index) => {
        return (
          <div key={index}>
            <Row>
                <InputGroup>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_product_label" label="Product ID" className="mb-3">
                      <Form.Control
                        type="number"
                        value={form.product_id}
                        readOnly
                      />
                    </FloatingLabel>
                  </Col>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_quantity_label" label="Quantity" className="mb-3">
                      <Form.Control
                        type="number"
                        value={form.quantity}
                        readOnly
                      />
                    </FloatingLabel>
                  </Col>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_quantity_label" label="Consumable Type" className="mb-3">
                      <Form.Control
                        type="string"
                        value={form.consumable_type}
                        readOnly
                      />
                    </FloatingLabel>
                  </Col>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_quantity_label" label="Consumable Quantity" className="mb-3">
                      <Form.Control
                        type="number"
                        value={form.consumable_quantity}
                        readOnly
                      />
                    </FloatingLabel>
                  </Col>
                  <Col className="p-1 col-auto">
                    <FloatingLabel id="floating_condition_label" label="Condition" className="mb-3">
                      <Form.Select>
                        <option>Please choose an option</option>
                        <option value="1">Accepted</option>
                        <option value="2">Damaged</option>
                        <option value="3">Faulty</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                </InputGroup>
            </Row>
          </div>
        )
      })}
      <Row>
        <Col className='col-auto'>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default TakeDelivery;
